<template>
    <div class="content">
        <div class="top-box">
            <div class="btn-home btn-active">数据概览</div>
            <div class="btn btn-device" @click="toDevice">设备管理</div>
            <div class="btn btn-patient" @click="toUser">患者管理</div>
            <div class="btn btn-data" @click="toData">手表数据</div>
            <div class="btn-admin"></div>
            <img class="btn-icon" src="@/assets/home/04icon.png">
            <div class="user-name" @click="toAdmin">{{ loginName }}</div>
            <div class="time-box">{{ time }}</div>
        </div>
        <div class="main">
            <div class="left-box">
                <div class="left-top-box">
                    <div class="s-title-box">
                        <img class="left-icon" src="@/assets/home/06left.png">
                        <div class="s-title">概览区</div>
                        <img class="right-icon" src="@/assets/home/06right.png">
                        <div class="latest-time" v-if="latestTime">最新数据同步时间 {{ latestTime }}</div>
                    </div>
                    <div class="s-item-box">
                        <img class="patient-icon" src="@/assets/home/07patient.png">
                        <div class="patient-title">患者总数</div>
                        <img class="patient-bg" src="@/assets/home/07bg.png">
                        <div class="patient-num">{{ formatNumberWithCommas(paintCount) }}</div>

                        <img class="watch-icon" src="@/assets/home/07watch.png">
                        <div class="watch-title">设备总数</div>
                        <img class="watch-bg" src="@/assets/home/07bg.png">
                        <div class="watch-num">{{ formatNumberWithCommas(deviceCount) }}</div>
                    </div>
                    <div class="s-chart-box">
                        <div class="num-unit">人</div>
                        <div class="age-unit">岁</div>
                        <div class="man-bar"></div>
                        <div class="man-text">男</div>
                        <div class="woman-bar"></div>
                        <div class="woman-text">女</div>
                        <div id="patient-line-chart"></div>
                        <div id="patient-pie-chart"></div>
                        <img class="chart-left-icon" src="@/assets/home/08left.svg">
                        <img class="chart-right-icon" src="@/assets/home/08right.svg">
                    </div>
                </div>
                <div class="left-bottom-box">
                    <div class="s-title-box w-title-box">
                        <img class="left-icon" src="@/assets/home/10left.png">
                        <div class="s-title w-title">预警区</div>
                        <img class="right-icon" src="@/assets/home/10right.png">
                    </div>
                    <div class="w-title-th">
                        <div class="w-title-name">患者姓名</div>
                        <div class="w-title-type">异常指标</div>
                        <div class="w-title-time">触发时间</div>
                    </div>
                    <div class="w-title-td-box">
                        <div class="w-title-td" v-for="(item, index) in errorInfo.errorUserList" :key="index">
                            <div class="w-title-name">{{ item.userName }}</div>
                            <div class="w-title-type">{{ item.errorType }}</div>
                            <div class="w-title-time">{{ item.errorTime }}</div>
                        </div>
                        <div class="no-error-user" v-if="errorInfo.errorUserList.length === 0">暂无数据</div>
                    </div>
                    <div class="total-title-box">
                        <div class="total-left"></div>
                        <div class="total-text">异常患者统计</div>
                        <div class="total-right"></div>
                    </div>
                    <div class="error-title-box">
                        <div class="error-line0"></div>
                        <div class="error-line1"></div>
                        <div class="error-line2"></div>
                        <div class="error-title">低血氧组</div>
                        <div class="error-more">详情</div>
                        <img class="error-more-icon" src="@/assets/home/11more.png">
                    </div>
                    <div class="error-value-box" v-if="errorInfo.lowBos.lowBosCount > 0">
                        <span class="value1">患者数：{{ errorInfo.lowBos.lowBosCount }}</span>
                        <span class="value2">平均血氧：{{ errorInfo.lowBos.avgBos }}%</span>
                        <span class="value3">最低血氧：{{ errorInfo.lowBos.minBos }}%</span>
                    </div>
                    <div class="error-value-box" v-if="errorInfo.lowBos.lowBosCount == 0">
                        暂无数据
                    </div>
                    <div class="error-title-box">
                        <div class="error-line0"></div>
                        <div class="error-line1"></div>
                        <div class="error-line2"></div>
                        <div class="error-title">高压力组</div>
                        <div class="error-more">详情</div>
                        <img class="error-more-icon" src="@/assets/home/11more.png">
                    </div>
                    <div class="error-value-box" v-if="errorInfo.highPressure.highPressureCount > 0">
                        <span class="value1">患者数：{{ errorInfo.highPressure.highPressureCount }}</span>
                        <span class="value2">平均压力：{{ errorInfo.highPressure.avgPressure }}</span>
                        <span class="value3">最大压力：{{errorInfo.highPressure.maxPressure}}</span>
                    </div>
                    <div class="error-value-box" v-if="errorInfo.highPressure.highPressureCount == 0">
                        暂无数据
                    </div>
                    <div class="error-title-box">
                        <div class="error-line0"></div>
                        <div class="error-line1"></div>
                        <div class="error-line2"></div>
                        <div class="error-title">睡眠异常组</div>
                        <div class="error-more">详情</div>
                        <img class="error-more-icon" src="@/assets/home/11more.png">
                    </div>
                    <div class="error-value-box" v-if="errorInfo.shortSleep.shortSleepCount > 0 || errorInfo.shortSleep.shortDeepSleepCount > 0">
                        <span class="value1">时长不足患者数 (＜6 h)：{{ errorInfo.shortSleep.shortSleepCount }}</span>
                        <span class="value3">深睡不足患者数 (＜20%)：{{ errorInfo.shortSleep.shortDeepSleepCount }}</span>
                    </div>
                    <div class="error-value-box" v-else>
                        暂无数据
                    </div>
                    <div class="error-title-box">
                        <div class="error-line0"></div>
                        <div class="error-line1"></div>
                        <div class="error-line2"></div>
                        <div class="error-title">心电异常组</div>
                        <div class="error-more">详情</div>
                        <img class="error-more-icon" src="@/assets/home/11more.png">
                    </div>
                    <div class="error-value-box" v-if="errorInfo.errorEcg.errorEcgCount > 0">
                        <span class="value1">患者数：{{ errorInfo.errorEcg.errorEcgCount }}</span>
                        <span class="value2">房颤占比：{{ errorInfo.errorEcg.fibrillationCount / errorInfo.errorEcg.errorEcgCount * 100 }} %</span>
                        <span class="value3">室性早搏占比：{{ errorInfo.errorEcg.atriaCount / errorInfo.errorEcg.errorEcgCount * 100 }} %</span>
                    </div>
                    <div class="error-value-box" v-if="errorInfo.errorEcg.errorEcgCount == 0">
                        暂无数据
                    </div>
                    <img class="chart-left-icon" src="@/assets/home/08leftRed.svg">
                    <img class="chart-right-icon" src="@/assets/home/08rightRed.svg">
                </div>
            </div>
            <div class="right-box">
                <div class="s-title-box right-title-box">
                    <img class="left-icon" src="@/assets/home/06left.png">
                    <div class="s-title">动态监测区</div>
                    <img class="right-icon d-right" src="@/assets/home/06right.png">
                </div>
                <div class="d-content">
                    <div class="d-left">
                        <div class="d-left-top">
                            <div class="d-title">
                                <img class="d-icon" src="@/assets/home/13dTitle.png">
                                <div class="d-text">心率</div>
                                <img class="d-sub-icon" src="@/assets/home/14sub.png">
                            </div>
                            <div class="avg-hr-box">
                                <div class="avg-hr-left">
                                    <img class="avg-hr-bg" src="@/assets/home/15bg.png">
                                    <div class="avg-hr-num">{{ dynamic.hr.avgHr }}</div>
                                    <div class="avg-hr-text">平均心率</div>
                                </div>
                                <div class="avg-hr-right">
                                    <img class="avg-hr-bg" src="@/assets/home/16bg.png">
                                    <div class="avg-hr-num">{{ dynamic.hr.avgBasicHr }}</div>
                                    <div class="avg-hr-text">平均静息心率</div>
                                </div>
                            </div>
                            <div class="range-title-box">
                                <div class="range-left"></div>
                                <div class="range-text">区间占比</div>
                                <div class="range-right"></div>
                            </div>
                            <div class="range-box">
                                <div class="range-box-left">
                                    <div id="range-chart"></div>
                                    <img class="range-icon" src="@/assets/home/17range.png">
                                </div>
                                <div class="range-box-right">
                                    <div class="range-bar0"></div>
                                    <div class="range-text0">心率正常</div>
                                    <div class="range-value0" v-if="dynamic.hr.count > 0">
                                        <span class="range-value-num0">{{ hrRatio.normalRatio }}%</span>
                                        （{{ dynamic.hr.normalCount }}人）
                                    </div>
                                    <div class="range-value0" v-else>
                                        <span class="range-value-num0">0%</span>
                                        （0人）
                                    </div>
                                    <div class="range-bar1"></div>
                                    <div class="range-text1">心率偏低</div>
                                    <div class="range-value1" v-if="dynamic.hr.count > 0">
                                        <span class="range-value-num1">{{ hrRatio.lowRatio }}%</span>
                                        （{{ dynamic.hr.lowCount }}人）
                                    </div>
                                    <div class="range-value1" v-else>
                                        <span class="range-value-num1">0%</span>
                                        （0人）
                                    </div>
                                    <div class="range-bar2"></div>
                                    <div class="range-text2">心率偏高</div>
                                    <div class="range-value2" v-if="dynamic.hr.count > 0">
                                        <span class="range-value-num2">{{ hrRatio.highRatio }}%</span>
                                        （{{ dynamic.hr.highCount }}人）
                                    </div>
                                    <div class="range-value2" v-else>
                                        <span class="range-value-num2">0%</span>
                                        （0人）
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-left-top">
                            <div class="d-title">
                                <img class="d-icon" src="@/assets/home/13dTitle.png">
                                <div class="d-text">睡眠</div>
                                <img class="d-sub-icon" src="@/assets/home/14sub.png">
                            </div>
                            <div class="avg-sleep-box">
                                <div class="avg-sleep-item">
                                    <div class="avg-sleep-title">平均睡眠时长</div>
                                    <div class="avg-sleep-value">{{formatSleepTime(dynamic.sleep.avgSleepTime) }}</div>
                                </div>
                                <div class="avg-sleep-item">
                                    <div class="avg-sleep-title">平均睡眠得分</div>
                                    <div class="avg-sleep-value avg-sleep-value1">{{ dynamic.sleep.avgSleepScore }}</div>
                                </div>
                            </div>
                            <div class="four-phase">四分期占比</div>
                            <div class="four-phase-item">
                                <div class="four-phase-title four-phase-title0">深睡</div>
                                <div class="four-phase-value">{{ formatSleepTime(dynamic.sleep.avgDeepTime) }} ({{ (sleepRatio.avgDeepTime * 100).toFixed(1) }}%)</div>
                                <div class="four-phase-progress-bg four-phase-progress-bg0"></div>
                                <div class="four-phase-progress-value four-phase-progress-value0" :style="{'width':250 * ratio * sleepRatio.avgDeepTime+'px'}"></div>
                                <div class="four-phase-level four-phase-level-normal" v-if="deepLevel === 0">正常</div>
                                <div class="four-phase-level four-phase-level-low" v-if="deepLevel === 1">偏低</div>
                                <div class="four-phase-level four-phase-level-high" v-if="deepLevel === 2">偏高</div>
                            </div>
                            <div class="four-phase-item">
                                <div class="four-phase-title four-phase-title1">浅睡</div>
                                <div class="four-phase-value">{{ formatSleepTime(dynamic.sleep.avgLightTime) }} ({{ (sleepRatio.avgLightTime * 100).toFixed(1) }}%)</div>
                                <div class="four-phase-progress-bg four-phase-progress-bg1"></div>
                                <div class="four-phase-progress-value four-phase-progress-value1" :style="{'width':250 * ratio * sleepRatio.avgLightTime+'px'}"></div>
                                <div class="four-phase-level four-phase-level-normal" v-if="lightLevel === 0">正常</div>
                                <div class="four-phase-level four-phase-level-high" v-if="lightLevel === 2">偏高</div>
                            </div>
                            <div class="four-phase-item">
                                <div class="four-phase-title four-phase-title2">快速眼动</div>
                                <div class="four-phase-value">{{ formatSleepTime(dynamic.sleep.avgRemTime) }} ({{ (sleepRatio.avgRemTime * 100).toFixed(1) }}%)</div>
                                <div class="four-phase-progress-bg four-phase-progress-bg2"></div>
                                <div class="four-phase-progress-value four-phase-progress-value2" :style="{'width':250 * ratio * sleepRatio.avgRemTime+'px'}"></div>
                                <div class="four-phase-level four-phase-level-normal" v-if="remLevel === 0">正常</div>
                                <div class="four-phase-level four-phase-level-low" v-if="remLevel === 1">偏低</div>
                                <div class="four-phase-level four-phase-level-high" v-if="remLevel === 2">偏高</div>
                            </div>
                            <div class="four-phase-item">
                                <div class="four-phase-title four-phase-title3">清醒</div>
                                <div class="four-phase-value">{{ formatSleepTime(dynamic.sleep.avgWakeTime) }} ({{ (sleepRatio.avgWakeTime * 100).toFixed(1) }}%)</div>
                                <div class="four-phase-progress-bg four-phase-progress-bg3"></div>
                                <div class="four-phase-progress-value four-phase-progress-value3" :style="{'width':250 * ratio * sleepRatio.avgWakeTime+'px'}"></div>
                                <div class="four-phase-level four-phase-level-normal" v-if="wakeLevel === 0">正常</div>
                                <div class="four-phase-level four-phase-level-high" v-if="wakeLevel === 2">偏高</div>
                            </div>
                            <div class="sleep-num-box">
                                <div class="sleep-num-item">
                                    <div class="sleep-num-value">
                                        <sapn class="sleep-num-num0">{{ errorInfo.shortSleep.shortSleepCount }}</sapn>
                                        人
                                    </div>
                                    <div class="sleep-num-key">总时长＜6h 患者</div>
                                </div>
                                <div class="sleep-num-item">
                                    <div class="sleep-num-value">
                                        <sapn class="sleep-num-num1">{{ errorInfo.shortSleep.shortDeepSleepCount }}</sapn>
                                        人
                                    </div>
                                    <div class="sleep-num-key">深睡占比＜20% 患者</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-left">
                        <div class="d-left-top">
                            <div class="d-title">
                                <img class="d-icon" src="@/assets/home/13dTitle.png">
                                <div class="d-text">压力</div>
                                <img class="d-sub-icon" src="@/assets/home/14sub.png">
                            </div>
                            <div class="pressure-chart-box">
                                <div id="pressure-chart"></div>
                                <div class="avg-pressure" :class="{'avg-pressure0':pressureLevel === 0,'avg-pressure1':pressureLevel === 1,'avg-pressure2':pressureLevel === 2,'avg-pressure3':pressureLevel === 3}">
                                    <div class="avg-pressure-value avg-pressure-value0"  v-if="pressureLevel === 0">{{ dynamic.pressure.avgPressure }}</div>
                                    <div class="avg-pressure-value avg-pressure-value1"  v-else-if="pressureLevel === 1">{{ dynamic.pressure.avgPressure }}</div>
                                    <div class="avg-pressure-value avg-pressure-value2"  v-else-if="pressureLevel === 2">{{ dynamic.pressure.avgPressure }}</div>
                                    <div class="avg-pressure-value avg-pressure-value3" v-else>{{ dynamic.pressure.avgPressure }}</div>
                                    <div class="avg-pressure-key">平均压力</div>
                                </div>
                            </div>
                            <div class="pressure-sub-title">
                                <div class="pressure-sub-title-bg"></div>
                                <div class="pressure-sub-title-text">中高压力集中时段</div>
                            </div>
                            <div class="pressure-bar-box">
                                <div class="pressure-num-unit">人</div>
                                <div id="pressure-bar-chart"></div>
                                <div class="select-pressure" v-if="selectPressureBar.time">
                                    <span class="select-pressure-time">{{ selectPressureBar.time }}</span>
                                    <span class="select-pressure-num">{{ selectPressureBar.value }}</span>人
                                </div>
                            </div>
                        </div>
                        <div class="d-left-top">
                            <div class="d-title">
                                <img class="d-icon" src="@/assets/home/13dTitle.png">
                                <div class="d-text">血氧饱和度</div>
                                <img class="d-sub-icon" src="@/assets/home/14sub.png">
                            </div>
                            <div class="avg-sleep-box avg-bos-box">
                                <div class="avg-bos-item">
                                    <div class="avg-sleep-title">测量总人数</div>
                                    <div class="avg-sleep-value">{{ formatNumberWithCommas(dynamic.bos.count) }}</div>
                                </div>
                                <div class="avg-bos-item">
                                    <div class="avg-sleep-title">测量总次数</div>
                                    <div class="avg-sleep-value">{{ formatNumberWithCommas(dynamic.bos.testCount) }}</div>
                                </div>
                            </div>
                            <div class="bos-chart-box">
                                <div id="bos-chart"></div>
                                <img class="bos-icon" src="@/assets/home/20bosChart.png">
                            </div>
                            <div class="pressure-ratio-box">
                                <div class="pressure-bar0"></div>
                                <div class="pressure-text0">血氧正常</div>
                                <div class="pressure-text-ratio-num0">{{ bosRatio.normalRatio ? bosRatio.normalRatio : 0 }}%</div>
                                <div class="pressure-text-num0">（{{ dynamic.bos.normalCount }}人）</div>
                                <div class="pressure-bar1"></div>
                                <div class="pressure-text1">轻度缺氧</div>
                                <div class="pressure-text-ratio-num1">{{ bosRatio.lightRatio ? bosRatio.lightRatio : 0 }}%</div>
                                <div class="pressure-text-num1">（{{ dynamic.bos.lightCount }}人）</div>
                                <div class="pressure-bar2"></div>
                                <div class="pressure-text2">中度缺氧</div>
                                <div class="pressure-text-ratio-num2">{{ bosRatio.middleRatio ? bosRatio.middleRatio : 0 }}%</div>
                                <div class="pressure-text-num2">（{{ dynamic.bos.middleCount }}人）</div>
                            </div>
                        </div>
                    </div>
                    <div class="ecg-box">
                        <div class="d-title">
                            <img class="d-icon" src="@/assets/home/13dTitle.png">
                            <div class="d-text">心电图</div>
                            <img class="d-sub-icon" src="@/assets/home/14sub.png">
                        </div>
                        <div class="ecg-total-box">
                            <div class="ecg-total-key">测量总时长</div>
                            <div class="ecg-total-value">{{ formatSecondsToTime(dynamic.ecg.duration) }}</div>
                        </div>
                        <div class="ecg-test-box">
                            <div class="ecg-test-item">
                                <div class="ecg-test-title">测量总人数</div>
                                <div class="ecg-test-value">{{ formatNumberWithCommas(dynamic.ecg.userCount) }}</div>
                            </div>
                            <div class="ecg-test-item">
                                <div class="ecg-test-title">测量总次数</div>
                                <div class="ecg-test-value">{{ formatNumberWithCommas(dynamic.ecg.testCount) }}</div>
                            </div>
                            <div class="ecg-test-item">
                                <div class="ecg-test-title">平均得分</div>
                                <div class="ecg-test-value">{{ dynamic.ecg.avgScore }}<span class="ecg-level" v-if="dynamic.ecg.avgScore > 0">{{ ecgLevel }}</span></div>
                            </div>
                        </div>
                        <div class="ecg-error-box">
                            <div class="ecg-error-title">异常事件统计</div>
                            <div>
                                <div class="ecg-error-info">
                                    <div class="ecg-error-left">
                                        <div class="ecg-error-type-order">1</div>
                                        <div class="ecg-error-type">房颤</div>
                                    </div>
                                    <div class="ecg-error-right">
                                        <div class="ecg-error-num">{{ dynamic.ecg.fibrillationCount }}</div>
                                        次
                                    </div>
                                </div>
                                <div class="ecg-error-progress-bg">
                                    <div class="ecg-error-progress-value" :style="{'width':390 * ratio * ecgErrorRatio.fibrillationRatio+'px'}"></div>
                                </div>
                            </div>
                            <div>
                                <div class="ecg-error-info">
                                    <div class="ecg-error-left">
                                        <div class="ecg-error-type-order">2</div>
                                        <div class="ecg-error-type">室性早搏</div>
                                    </div>
                                    <div class="ecg-error-right">
                                        <div class="ecg-error-num">{{ dynamic.ecg.atriaCount }}</div>
                                        次
                                    </div>
                                </div>
                                <div class="ecg-error-progress-bg">
                                    <div class="ecg-error-progress-value" :style="{'width':390 * ratio * ecgErrorRatio.atriaRatio+'px'}"></div>
                                </div>
                            </div>
                            <div>
                                <div class="ecg-error-info">
                                    <div class="ecg-error-left">
                                        <div class="ecg-error-type-order">3</div>
                                        <div class="ecg-error-type">室上性早搏</div>
                                    </div>
                                    <div class="ecg-error-right">
                                        <div class="ecg-error-num">{{ dynamic.ecg.atriumCount }}</div>
                                        次
                                    </div>
                                </div>
                                <div class="ecg-error-progress-bg">
                                    <div class="ecg-error-progress-value" :style="{'width':390 * ratio * ecgErrorRatio.atriumRatio+'px'}"></div>
                                </div>
                            </div>
                            <div>
                                <div class="ecg-error-info">
                                    <div class="ecg-error-left">
                                        <div class="ecg-error-type-order">4</div>
                                        <div class="ecg-error-type">长RR间期</div>
                                    </div>
                                    <div class="ecg-error-right">
                                        <div class="ecg-error-num">{{ dynamic.ecg.longRRCount }}</div>
                                        次
                                    </div>
                                </div>
                                <div class="ecg-error-progress-bg">
                                    <div class="ecg-error-progress-value" :style="{'width':390 * ratio * ecgErrorRatio.longRRRatio+'px'}"></div>
                                </div>
                            </div>
                            <div class="range-title-box">
                                <div class="range-left"></div>
                                <div class="range-text">节律分析</div>
                                <div class="range-right"></div>
                            </div>
                            <div class="ecg-hr-box">
                                <div class="ecg-hr-item">
                                    <div class="ecg-hr-title">心率过缓</div>
                                    <div class="ecg-hr-value"><span class="ecg-hr-num">{{ dynamic.ecg.lowHrCount }}</span>人</div>
                                    <img class="ecg-icon" src="@/assets/home/22hrSlow.png">
                                </div>
                                <div class="ecg-hr-item">
                                    <div class="ecg-hr-title">心率过速</div>
                                    <div class="ecg-hr-value"><span class="ecg-hr-num">{{  dynamic.ecg.highHrCount }}</span>人</div>
                                    <img class="ecg-icon" src="@/assets/home/22hrFast.png">
                                </div>
                            </div>
                        </div>
                        <div class="range-title-box">
                            <div class="range-left"></div>
                            <div class="range-text">HRV</div>
                            <div class="range-right"></div>
                        </div>
                        <div class="pressure-chart-box">
                            <div id="hrv-chart"></div>
                            <div class="avg-hrv" :class="{'avg-pressure0':hrvLevel === 0,'avg-pressure1':hrvLevel === 1,'avg-pressure2':hrvLevel === 2,'avg-pressure3':hrvLevel === 3}">
                                <div class="avg-pressure-value avg-pressure-value0"  v-if="hrvLevel === 0">{{ dynamic.ecg.avgHrv }}</div>
                                <div class="avg-pressure-value avg-pressure-value1"  v-else-if="hrvLevel === 1">{{ dynamic.ecg.avgHrv }}</div>
                                <div class="avg-pressure-value avg-pressure-value2"  v-else-if="hrvLevel === 2">{{ dynamic.ecg.avgHrv }}</div>
                                <div class="avg-pressure-value avg-pressure-value3" v-else>{{ dynamic.ecg.avgHrv }}</div>
                                <div class="avg-pressure-key">平均值</div>
                            </div>
                        </div>
                    </div>
                </div>
                <img class="chart-left-icon" src="@/assets/home/08left.svg">
                <img class="chart-right-icon" src="@/assets/home/08right.svg">
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/store'

export default {
    name: 'index',
    data() {
        return {
            loginName:'',
            time: '',
            latestTime: '',
            ratio: 1,
            pressureXData: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '00:00']
            ,
            selectPressureBar: {
                time: '',
                value: ''
            },
            paintCount: '',
            paintWomanData: [],
            paintManData: [],
            paintWoman: 0,
            paintMan: 0,
            deviceCount: 0,
            errorInfo: {
                "errorUserList": [],
                "lowBos": {
                    "lowBosCount": 0,
                    "minBos": null,
                    "avgBos": null
                },
                "highPressure": {
                    "highPressureCount": 0,
                    "maxPressure": 0,
                    "avgPressure": 0
                },
                "shortSleep": {
                    "shortSleepCount": 0,
                    "shortDeepSleepCount": 0
                },
                "errorEcg": {
                    "errorEcgCount": 0,
                    "arrhythmiaCount": 0,
                    "fibrillationCount": 0,
                    "atriumCount": 0,
                    "atriaCount": 0,
                    "longRRCount": 0
                }
            },
            dynamic: {
                "hr": {
                    "avgHr": 0,
                    "avgBasicHr": 0,
                    "count": 0,
                    "normalCount": 0,
                    "lowCount": 0,
                    "highCount": 0
                },
                "sleep": {
                    "avgSleepTime": 0,
                    "avgSleepScore": 0,
                    "avgWakeTime": 0,
                    "avgRemTime": 0,
                    "avgDeepTime": 0,
                    "avgLightTime": 0
                },
                "pressure": {
                    "avgPressure": 0,
                    "count": 0,
                    "relaxCount": 0,
                    "normalCount": 0,
                    "middleCount": 0,
                    "highCount": 0
                },
                "bos": {
                    "count": 0,
                    "normalCount": 0,
                    "lightCount": 0,
                    "middleCount": 0,
                    testCount: 0
                },
                "ecg": {
                    "duration": 0,
                    "userCount": 0,
                    "testCount": 0,
                    "avgScore": 0,
                    "arrhythmiaCount": 0,
                    "fibrillationCount": 0,
                    "atriumCount": 0,
                    "atriaCount": 0,
                    "longRRCount": 0,
                    "lowHrCount": 0,
                    "highHrCount": 0,
                    "avgHrv": 0,
                    "excellentHrvCount": 0,
                    "goodHrvCount": 0,
                    "middleHrvCount": 0,
                    "poorHrvCount": 0
                }
            },
            hrRatio: {
                normalRatio: 0,
                lowRatio: 0,
                highRatio: 0
            },
            sleepRatio: {
                "avgWakeTime": 0,
                "avgRemTime": 0,
                "avgDeepTime": 0,
                "avgLightTime": 0
            },
            bosRatio: {
                normalRatio: 0,
                lightRatio: 0,
                middleRatio: 0
            },
            deepLevel: 0, //深睡 0-正常 1-偏低 2-偏高
            lightLevel: 0, //浅睡 0-正常 1-偏低 2-偏高
            remLevel: 0, // 快速眼动 0-正常 1-偏低 2-偏高
            wakeLevel: 0, // 清醒
            pressureLevel: 0,
            ecgErrorRatio: {
                "longRRRatio": 0,
                "fibrillationRatio": 0,
                "atriumRatio": 0,
                "atriaRatio": 0,
            },
            hrvLevel: 0,
            ecgLevel: ''
        }
    },
    computed: {
        // 滚动区高度
        scrollerHeight: function () {
            return (window.innerHeight) + 'px'; //自定义高度需求
        }
    },
    mounted() {
        this.loginName = localStorage.getItem('phone');
        this.ratio = document.documentElement.clientWidth / 1920;
        this.startTimer();
        this.getPaintCount();
        this.getDeviceCount();
        this.getErrorInfo();
        this.getDynamic();
    },
    methods: {
        toDevice() {
            this.$router.push({
                name: 'device'
            })
        },
        toUser() {
            this.$router.push({
                name: 'user'
            })
        },
        toData() {
            this.$router.push({
                name: 'data'
            })
        },
        getTime() {
            let time = new Date();
            let year = time.getFullYear();
            let month = (time.getMonth() + 1).toString().padStart(2, '0');
            let day = time.getDate().toString().padStart(2, '0');
            let hour = time.getHours().toString().padStart(2, '0');
            let minute = time.getMinutes().toString().padStart(2, '0');
            let second = time.getSeconds().toString().padStart(2, '0');
            this.time = year + '/' + month + '/' + day + '\n' + hour + ':' + minute + ':' + second;
        },
        startTimer() {
            // 立即执行一次
            this.getTime();
            // 每秒执行一次
            setInterval(() => {
                this.getTime();
            }, 1000);
        },
        getPaintCount() {
            this.$api.home.getUserStatistics().then(res => {
                this.paintWoman = res.data.womanNum;
                this.paintMan = res.data.manNum;
                this.paintCount = this.paintWoman + this.paintMan;
                this.paintWomanData = res.data.woman.map(item => -item);
                this.paintManData = res.data.man;
                this.latestTime = res.data.latestTime;
                this.$nextTick(() => {
                    this.drawPaintLineChart()
                    this.drawPaintPieChart()
                })
            })
        },
        drawPaintLineChart() {
            let myChart = this.$echarts.init(document.getElementById('patient-line-chart'));
            let option = {
                tooltip: {
                    backgroundColor: '#0A192F',
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params, ticket, callback) {
                        let item = params[0];
                        let item1 = params[1];
                        let html = '';
                        html += '<div style="color: #ffffff" >' + item.axisValue + '</div>'
                        html += '<div><span style="color: #BBBBBB" >男：</span><span style="color: #ffffff" >' + item.data + '</span></div>'
                        html += '<div><span style="color: #BBBBBB" >女：</span><span style="color: #ffffff" >' + Math.abs(item1.data) + '</span></div>'
                        return html
                    }
                },
                grid: {
                    top: 10 * this.ratio,
                    bottom: 25 * this.ratio,
                    left: 40 * this.ratio,
                    right: 10 * this.ratio
                },
                legend: {
                    show: false
                },
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            fontSize: 10 * this.ratio,
                            textStyle: {
                                color: '#ffffff'
                            },
                            formatter: function (value) {
                                return Math.abs(value)
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#4F607D',
                                type: 'dashed'
                            }
                        },
                        splitNumber: 4
                    }
                ],
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            fontSize: 10 * this.ratio,
                            textStyle: {
                                color: '#ffffff'
                            },
                            interval: 0,
                        },
                        data: ['0-20', '20-30', '30-40', '40-50', '50-60', '60-70', '70以上']
                    }
                ],
                series: [
                    {
                        name: '男',
                        type: 'bar',
                        stack: 'Total',
                        color: '#1CB9FF',
                        barWidth: 9 * this.ratio,
                        data: this.paintManData,
                    },
                    {
                        name: '女',
                        type: 'bar',
                        stack: 'Total',
                        color: '#0CE989',
                        barWidth: 9 * this.ratio,
                        data: this.paintWomanData
                    }
                ]
            };
            myChart.setOption(option);
        },
        drawPaintPieChart() {
            let _this = this;
            let myChart = this.$echarts.init(document.getElementById('patient-pie-chart'));
            let option = {
                tooltip: {
                    backgroundColor: '#0A192F',
                    trigger: 'item',
                    textStyle: {
                        color: '#ffffff'
                    },
                    formatter: function (params) {
                        let percentage = ((params.data.value / _this.paintCount) * 100).toFixed(1);
                        let html = '';
                        html += '<div><span style="color: ' + params.color + ';font-size: 16px; font-family: CK;letter-spacing: 2px;" >' + params.data.value + '</span><span style="color: #ffffff;font-size: 10px;margin-left: 5px" >人</span></div>'
                        html += '<div><span style="color: #ffffff;font-size: 10px" >' + percentage + '%</span></div>'
                        return html
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: '80%',
                        label: {
                            show: false,
                            position: 'center'
                        },
                        data: [
                            {value: this.paintMan, name: '男', itemStyle: {color: '#1CB9FF'}},
                            {value: this.paintWoman, name: '女', itemStyle: {color: '#0CE989'}},
                        ]
                    }
                ]
            };
            myChart.setOption(option);
        },
        getErrorInfo() {
            this.$api.home.getErrorInfo().then(res => {
                this.errorInfo = res.data
            })
        },
        getDynamic() {
            this.$api.home.getDynamic().then(res => {
                this.dynamic = res.data
                if (this.dynamic.sleep.avgSleepTime) {
                    this.sleepRatio = {
                        "avgWakeTime": this.dynamic.sleep.avgWakeTime / this.dynamic.sleep.avgSleepTime,
                        "avgRemTime": this.dynamic.sleep.avgRemTime / this.dynamic.sleep.avgSleepTime,
                        "avgDeepTime": this.dynamic.sleep.avgDeepTime / this.dynamic.sleep.avgSleepTime,
                        "avgLightTime": this.dynamic.sleep.avgLightTime / this.dynamic.sleep.avgSleepTime,
                    }
                    if (this.sleepRatio.avgDeepTime < 0.2) {
                        this.deepLevel = 1
                    } else if (this.sleepRatio.avgDeepTime < 0.6) {
                        this.deepLevel = 0
                    } else {
                        this.deepLevel = 2
                    }
                    if (this.sleepRatio.avgLightTime < 0.55) {
                        this.lightLevel = 0
                    } else {
                        this.lightLevel = 2
                    }
                    if (this.sleepRatio.avgRemTime < 0.1) {
                        this.remLevel = 1
                    } else if (this.sleepRatio.avgDeepTime < 0.3) {
                        this.remLevel = 0
                    } else {
                        this.remLevel = 2
                    }

                    if (this.sleepRatio.avgWakeTime > 0.05) {
                        this.wakeLevel = 2
                    } else {
                        this.wakeLevel = 0
                    }
                }

                if (this.dynamic.pressure.avgPressure >= 80) {
                    this.pressureLevel = 3
                } else if (this.dynamic.pressure.avgPressure >= 60) {
                    this.pressureLevel = 2
                } else if (this.dynamic.pressure.avgPressure >= 30) {
                    this.pressureLevel = 1
                } else {
                    this.pressureLevel = 0
                }

                if (this.dynamic.hr.count > 0) {
                    this.hrRatio = {
                        normalRatio: (this.dynamic.hr.normalCount / this.dynamic.hr.count).toFixed(4) * 100,
                        lowRatio: (this.dynamic.hr.lowCount / this.dynamic.hr.count).toFixed(4) * 100,
                        highRatio: (this.dynamic.hr.highCount / this.dynamic.hr.count).toFixed(4) * 100
                    }
                }

                if (this.dynamic.bos.count > 0) {
                    this.bosRatio = {
                        normalRatio: (this.dynamic.bos.normalCount / this.dynamic.bos.count).toFixed(4) * 100,
                        lowRatio: (this.dynamic.bos.lowCount / this.dynamic.bos.count).toFixed(4) * 100,
                        highRatio: (this.dynamic.bos.highCount / this.dynamic.bos.count).toFixed(4) * 100
                    }
                }

                if (this.dynamic.ecg.errorCount > 0) {
                   this.ecgErrorRatio = {
                       fibrillationRatio: this.dynamic.ecg.fibrillationCount / this.dynamic.ecg.errorCount,
                       longRRRatio: this.dynamic.ecg.longRRCount / this.dynamic.ecg.errorCount,
                       atriaRatio:  this.dynamic.ecg.atriaCount / this.dynamic.ecg.errorCount,
                       atriumRatio: this.dynamic.ecg.atriumCount / this.dynamic.ecg.errorCount
                   }
                }

                if (this.dynamic.ecg.avgHrv > 47) {
                    this.hrvLevel = 0
                } else if (this.dynamic.ecg.avgHrv >= 34) {
                    this.hrvLevel = 1
                } else if (this.dynamic.ecg.avgHrv >= 21) {
                    this.hrvLevel = 2
                } else {
                    this.hrvLevel = 3
                }

                this.ecgLevel = this.getEcgLevel(this.dynamic.ecg.avgScore);

                this.$nextTick(() => {
                    this.drawRangeChart();
                    this.drawPressurePieChart();
                    this.drawPressureBarChart();
                    this.drawBosChart();
                    this.drawHrvChart();
                })
            })
        },
        drawRangeChart() {
            let myChart = this.$echarts.init(document.getElementById('range-chart'));
            let option = {
                grid: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['80%', '100%'],
                        label: {
                            show: false,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        },
                        emphasis: {
                            scale: false,
                            disabled: true
                        },
                        data: [
                            {value: this.dynamic.hr.normalCount, itemStyle: {color: '#1CB9FF'}},
                            {value: this.dynamic.hr.lowCount, itemStyle: {color: '#0CE989'}},
                            {value: this.dynamic.hr.highCount, itemStyle: {color: '#FFBC36'}},
                        ]
                    }, {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['60%', '80%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            scale: false,
                            disabled: true
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {value: this.dynamic.hr.normalCount, itemStyle: {color: 'rgba(28, 185, 255, 0.3)'}},
                            {value: this.dynamic.hr.lowCount, itemStyle: {color: 'rgba(255, 188, 54, 0.3)'}},
                            {value: this.dynamic.hr.highCount, itemStyle: {color: 'rgba(12, 233, 137, 0.3)'}},
                        ]
                    }
                ]
            };
            myChart.setOption(option);
        },
        drawPressurePieChart() {
            let myChart = this.$echarts.init(document.getElementById('pressure-chart'));
            var scale = this.ratio;

            // 原始数据项
            var originalData = [{
                value: this.dynamic.pressure.relaxCount,
                name: '放松',
                color: '#0CE989',
                index: 0
            }, {
                value: this.dynamic.pressure.normalCount,
                name: '正常',
                color: '#1CB9FF',
                index: 1
            }, {
                value: this.dynamic.pressure.middleCount,
                name: '中等',
                color: '#FFBC36',
                index: 2
            }, {
                value: this.dynamic.pressure.highCount,
                name: '偏高',
                color: '#FF3A62',
                index: 3
            }];

            // 过滤掉值为0的数据
            var filteredData = originalData.filter(item => item.value > 0);

            // 提取颜色数组，与过滤后的数据对应
            var colors = filteredData.map(item => item.color);

            // 构造echart数据格式
            var echartData = filteredData.map(item => ({
                value: item.value,
                name: item.name
            }));

            // 动态构建rich对象，只包含有效数据项的样式
            var rich = {};
            filteredData.forEach((item, filteredIndex) => {
                const originalIndex = item.index;
                rich[`title${filteredIndex}`] = {
                    color: item.color,
                    fontSize: 14 * scale,
                    align: 'left'
                };
                rich[`value${filteredIndex}`] = {
                    color: item.color,
                    fontSize: 16 * scale,
                    align: 'left',
                    padding: [4 * scale, 4 * scale, 8 * scale, 0],
                    fontFamily: 'CK'
                };
            });
            // 添加通用的文本样式
            rich.nText = {
                color: "#ffffff",
                fontSize: 10 * scale,
                align: 'left',
            };

            let option = {
                series: [{
                    type: 'pie',
                    radius: ['53%', '70%'],
                    center: ['50%', '50%'],
                    hoverAnimation: false,
                    color: colors, // 使用过滤后的颜色数组
                    itemStyle: {
                        borderColor: '#041633',
                        borderWidth: 2
                    },
                    label: {
                        normal: {
                            formatter: function (params, ticket, callback) {
                                if (params.value > 0) {
                                    var total = 0;
                                    echartData.forEach(function (value) {
                                        total += value.value;
                                    });
                                    var percent = ((params.value / total) * 100).toFixed(1);
                                    return '{title' + params.dataIndex + '|' + params.name + '}\n{value' + params.dataIndex + '|' + params.value + '}{nText|人}\n{nText|' + percent + '%}';
                                } else {
                                    return '';
                                }
                            },
                            rich: rich
                        },
                    },
                    data: echartData // 使用过滤后的数据
                }]
            };
            myChart.setOption(option);
        },
        drawPressureBarChart() {
            let myChart = this.$echarts.init(document.getElementById('pressure-bar-chart'));
            let yData = this.dynamic.pressure.middleHighPressure;
            let _this = this;
            let option = {
                grid: {
                    top: 10 * this.ratio,
                    bottom: 40 * this.ratio,
                    left: 30 * this.ratio,
                    right: 20 * this.ratio
                },
                yAxis: [
                    {
                        type: 'value',
                        minInterval: 1,
                        axisLabel: {
                            fontSize: 10 * this.ratio,
                            textStyle: {
                                color: '#ffffff'
                            },
                            formatter: function (value) {
                                return Math.abs(value)
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#4F607D',
                                type: 'dashed'
                            }
                        },
                        splitNumber: 3
                    }
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params, ticket, callback) {
                        let item = params[0];
                        if (item.dataIndex < _this.pressureXData.length - 1)
                            _this.selectPressureBar.time = _this.pressureXData[item.dataIndex] + ' - ' + _this.pressureXData[item.dataIndex + 1];
                        _this.selectPressureBar.value = item.data;
                    }
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            fontSize: 10 * this.ratio,
                            textStyle: {
                                color: '#ffffff'
                            },
                            interval: 35,
                        },
                        data: this.pressureXData,
                    }
                ],
                series: [
                    {
                        data: yData,
                        type: 'bar',
                        barWidth: 4 * this.ratio,
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {offset: 0, color: '#FF3A62'},
                                {offset: 1, color: '#FFBC36'}
                            ]),
                            borderRadius: [5 * this.ratio, 5 * this.ratio, 0, 0]
                        },
                    }
                ]
            };
            myChart.setOption(option);
            myChart.on('globalout', function (params) {
                _this.selectPressureBar = {
                    time: '',
                    value: ''
                }
            });
        },
        drawBosChart() {
            let myChart = this.$echarts.init(document.getElementById('bos-chart'));
            let dataArr = [];
            for (var i = 0; i < 75; i++) {
                if (i % 2 === 0) {
                    dataArr.push({
                        name: (i + 1).toString(),
                        value: 25,
                        itemStyle: {
                            normal: {
                                color: "rgba(0, 136, 255, 0.65)",
                                borderWidth: 0,
                                borderColor: "rgba(0,0,0,0)"
                            }
                        }
                    })
                } else {
                    dataArr.push({
                        name: (i + 1).toString(),
                        value: 20,
                        itemStyle: {
                            normal: {
                                color: "rgba(0,0,0,0)",
                                borderWidth: 0,
                                borderColor: "rgba(0,0,0,0)"
                            }
                        }
                    })
                }

            }
            let dataArr1 = [];
            for (var i = 0; i < 250; i++) {
                if (i % 2 === 0) {
                    dataArr1.push({
                        name: (i + 1).toString(),
                        value: 10,
                        itemStyle: {
                            normal: {
                                color: "rgba(0, 136, 255, 0.65)",
                                borderWidth: 0,
                                borderColor: "rgba(0,0,0,0)"
                            }
                        }
                    })
                } else {
                    dataArr1.push({
                        name: (i + 1).toString(),
                        value: 20,
                        itemStyle: {
                            normal: {
                                color: "rgba(0,0,0,0)",
                                borderWidth: 0,
                                borderColor: "rgba(0,0,0,0)"
                            }
                        }
                    })
                }

            }
            let option = {
                grid: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                },
                series: [
                    {
                        type: 'pie',
                        silent: true,
                        radius: ['94%', '100%'],
                        label: {
                            normal: {
                                show: false
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: dataArr1
                    },
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['70%', '88%'],
                        label: {
                            show: false,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        },
                        emphasis: {
                            scale: false,
                            disabled: true
                        },
                        data: [
                            {value: this.dynamic.bos.normalCount, itemStyle: {color: '#1CB9FF'}},
                            {value: this.dynamic.bos.lightCount, itemStyle: {color: '#FFBC36'}},
                            {value: this.dynamic.bos.middleCount, itemStyle: {color: '#FF3A62'}},
                        ]
                    },
                    {
                        type: 'pie',
                        silent: true,
                        radius: ['60%', '61%'],
                        label: {
                            normal: {
                                show: false
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: dataArr
                    },
                    {
                        type: 'pie',
                        silent: true,
                        radius: ['45%', '46%'],
                        label: {
                            normal: {
                                show: false
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: dataArr
                    },
                ]
            };
            myChart.setOption(option);
        },
        drawHrvChart() {
            let myChart = this.$echarts.init(document.getElementById('hrv-chart'));
            var scale = this.ratio;

            // 原始数据项
            var originalData = [{
                value: this.dynamic.ecg.excellentHrvCount,
                name: '优',
                color: '#0CE989',
                index: 0
            }, {
                value: this.dynamic.ecg.middleHrvCount,
                name: '中',
                color: '#1CB9FF',
                index: 1
            }, {
                value: this.dynamic.ecg.goodHrvCount,
                name: '良',
                color: '#FFBC36',
                index: 2
            }, {
                value: this.dynamic.ecg.poorHrvCount,
                name: '差',
                color: '#FF3A62',
                index: 3
            }];

            // 过滤掉值为0的数据
            var filteredData = originalData.filter(item => item.value > 0);

            // 构造echart数据格式
            var echartData = filteredData.map(item => ({
                value: item.value,
                name: item.name
            }));

            // 提取颜色数组，与过滤后的数据对应
            var colors = filteredData.map(item => item.color);

            // 动态构建rich对象，只包含有效数据项的样式
            var rich = {};
            filteredData.forEach((item, filteredIndex) => {
                const originalIndex = item.index;
                rich[`title${filteredIndex}`] = {
                    color: item.color,
                    fontSize: 14 * scale,
                    align: 'left'
                };
                rich[`value${filteredIndex}`] = {
                    color: item.color,
                    fontSize: 16 * scale,
                    align: 'left',
                    padding: [4 * scale, 4 * scale, 8 * scale, 0],
                    fontFamily: 'CK'
                };
            });
            // 添加通用的文本样式
            rich.nText = {
                color: "#ffffff",
                fontSize: 10 * scale,
                align: 'left',
            };

            let option = {
                series: [{
                    type: 'pie',
                    radius: ['53%', '70%'],
                    center: ['50%', '50%'],
                    hoverAnimation: false,
                    color: colors, // 使用过滤后的颜色数组
                    itemStyle: {
                        borderColor: '#041633',
                        borderWidth: 2
                    },
                    label: {
                        normal: {
                            formatter: function (params, ticket, callback) {
                                if (params.value > 0) {
                                    var total = 0;
                                    echartData.forEach(function (value) {
                                        total += value.value;
                                    });
                                    var percent = ((params.value / total) * 100).toFixed(1);
                                    return '{title' + params.dataIndex + '|' + params.name + '}\n{value' + params.dataIndex + '|' + params.value + '}{nText|人}\n{nText|' + percent + '%}';
                                } else {
                                    return '';
                                }
                            },
                            rich: rich // 使用动态构建的rich对象
                        },
                    },
                    data: echartData // 使用过滤后的数据
                }]
            };
            myChart.setOption(option);
        },
        formatNumberWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatSleepTime(minutes) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = Math.floor(minutes % 60);
            return `${hours} h ${remainingMinutes} min`;
        },
        getDeviceCount() {
            this.$api.home.getDeviceCount().then(res => {
                this.deviceCount = res.data
            })
        },
        formatSecondsToTime(seconds) {
            const hrs = Math.floor(seconds / 3600);
            const mins = Math.floor((seconds % 3600) / 60);
            const secs = Math.floor(seconds % 60);

            return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        },
        getEcgLevel(score) {
            if (score > 0 && score < 60) {
                return "差";
            } else if (score >= 60 && score < 70) {
                return "较差";
            } else if (score >= 70 && score < 80) {
                return "一般";
            } else if (score >= 80 && score <= 89) {
                return "良好";
            } else if (score >= 90) {
                return "优";
            } else {
                return "--";
            }
        },
        toAdmin() {
            this.$router.push({ path: '/admin' });
        }
    }
}
</script>

<style scoped>
.content {
    width: 1920px;
    height: 1080px;
    background-color: #0A192F;
    background-image: url("~@/assets/home/01bg.png");
    background-size: cover;
    box-sizing: border-box;
    overflow-x: hidden;
}

.dd {
    width: 280px;
    height: 50px;
    background: linear-gradient(120deg, #0089FF 0%, #1CB9FF 100%);
}

.main {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.left-box {
    width: 525px;
    margin-left: 63px;
}

.left-top-box {
    width: 521px;
    height: 318px;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 0px 0px 0px 0px;
}

.s-title-box {
    width: 525px;
    height: 58px;
    background-image: url("~@/assets/home/05titleBg.png");
    background-size: cover;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
}

.left-icon {
    width: 19px;
    position: absolute;
    left: 24px;
    top: 15px;
}

.s-title {
    font-family: PM;
    font-size: 29px;
    color: #1CB9FF;
    position: absolute;
    left: 52px;
    top: 7px;
}

.right-icon {
    width: 19px;
    position: absolute;
    left: 145px;
    top: 15px;
}

.latest-time {
    position: absolute;
    font-size: 14px;
    color: #FFFFFF;
    right: 30px;
    top: 5px;
}

.s-item-box {
    width: 100%;
    height: 96px;
    position: relative;
}

.patient-icon {
    width: 70px;
    position: absolute;
    left: 46px;
    top: 0px;
}

.patient-title {
    font-size: 18px;
    color: #FFFFFF;
    position: absolute;
    left: 135px;
    top: 8px;
    line-height: 18px;
}

.patient-bg {
    width: 80px;
    position: absolute;
    left: 135px;
    top: 18px;
}

.patient-num {
    font-family: CK;
    font-size: 34px;
    color: #FFFFFF;
    position: absolute;
    left: 135px;
    top: 32px;
    letter-spacing: 2px;
}

.watch-icon {
    width: 70px;
    position: absolute;
    left: 300px;
    top: 0px;
}

.watch-title {
    font-size: 18px;
    color: #FFFFFF;
    position: absolute;
    left: 389px;
    top: 8px;
    line-height: 18px;
}

.watch-bg {
    width: 80px;
    position: absolute;
    left: 389px;
    top: 18px;
}

.watch-num {
    font-family: CK;
    font-size: 34px;
    color: #FFFFFF;
    position: absolute;
    left: 389px;
    top: 32px;
    letter-spacing: 2px;
}

.s-chart-box {
    width: 100%;
    position: relative;
    height: 164px;
}

.num-unit {
    font-size: 10px;
    color: #FFFFFF;
    position: absolute;
    left: 18px;
}

.age-unit {
    font-size: 10px;
    color: #FFFFFF;
    position: absolute;
    left: 337px;
    bottom: 4px;
}

.man-bar {
    width: 9px;
    height: 9px;
    background: #1CB9FF;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    left: 266px;
    top: 4px;
}

.man-text {
    font-size: 10px;
    color: #FFFFFF;
    position: absolute;
    left: 279px;
}

.woman-bar {
    width: 9px;
    height: 9px;
    background: #0CE989;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    left: 305px;
    top: 4px;
}

.woman-text {
    font-size: 10px;
    color: #FFFFFF;
    position: absolute;
    left: 318px;
}

#patient-line-chart {
    width: 337px;
    height: 150px;
    bottom: 0;
    position: absolute;
    left: 0;
}

#patient-pie-chart {
    width: 174px;
    height: 150px;
    bottom: 0;
    position: absolute;
    right: 0;
}

.chart-left-icon {
    width: 14px;
    position: absolute;
    bottom: 0;
    left: 0;
}

.chart-right-icon {
    width: 14px;
    position: absolute;
    bottom: 0;
    right: 0;
}

.left-bottom-box {
    margin-top: 30px;
    width: 100%;
    height: 563px;
    background: rgba(255, 0, 0, 0.13);
    position: relative;
}

.w-title-box {
    background-image: url("~@/assets/home/09bg.png");
}

.w-title {
    color: #FF3A62;
}

.w-title-th {
    width: 481px;
    height: 36px;
    background: linear-gradient(180deg, rgba(8, 20, 48, 0) 0%, rgba(101, 19, 36, 0.88) 100%);
    box-shadow: inset 0px -1px 2px 1px #FF3A62;
    border-radius: 0px 0px 0px 0px;
    margin-left: 20px;
    margin-top: -5px;
    position: relative;
    font-size: 14px;
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.w-title-name {
    width: calc(25% - 34px);
    padding-left: 34px;
}

.w-title-type {
    width: 45%;
    text-align: center;
}

.w-title-time {
    width: 30%;
}

.w-title-td-box {
    width: 481px;
    height: 79px;
    background: rgba(255, 58, 98, 0.1);
    box-shadow: inset 0px 0px 3px 1px #FF0034;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid rgba(255, 58, 98, 0.5);
    margin-left: 20px;
    margin-top: 6px;
    font-size: 14px;
    color: #FFFFFF;
}

.w-title-td {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
}

.w-title-td:not(:first-child) {
    margin-top: 16px;
}

.w-title-td .w-title-type {
    color: #FF3A62;
}

.total-title-box {
    width: 100%;
    height: 48px;
    position: relative;
}

.total-left {
    width: 92px;
    height: 2px;
    background: linear-gradient(270deg, #FFFFFF 0%, rgba(5, 27, 55, 0) 100%);
    position: absolute;
    left: 112px;
    top: 22px;
}

.total-right {
    width: 92px;
    height: 2px;
    background: linear-gradient(90deg, #FFFFFF 0%, rgba(5, 27, 55, 0) 100%);
    right: 112px;
    top: 22px;
    position: absolute;
}

.total-text {
    font-size: 16px;
    font-family: PM;
    position: absolute;
    left: 204px;
    top: 14px;
    color: #FFFFFF;
    width: 113px;
    text-align: center;
}

.error-title-box {
    width: 481px;
    height: 36px;
    background: linear-gradient(270deg, rgba(8, 20, 48, 0) 0%, rgba(101, 19, 36, 0.88) 100%);
    border-radius: 0px 0px 0px 0px;
    margin: 0 20px;
    position: relative;
}

.error-line0 {
    width: 3px;
    height: 24px;
    background: #FF3A62;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    left: 0;
    top: 6px;
}

.error-line1 {
    width: 3px;
    height: 14px;
    background: #FF3A62;
    border-radius: 0px 0px 0px 0px;
    opacity: 0.7;
    position: absolute;
    left: 6px;
    top: 11px;
}

.error-line2 {
    width: 3px;
    height: 8px;
    background: #FF3A62;
    border-radius: 0px 0px 0px 0px;
    opacity: 0.4;
    position: absolute;
    left: 12px;
    top: 14px;
}

.error-title {
    font-size: 20px;
    color: #FF3A62;
    letter-spacing: 1.5px;
    position: absolute;
    left: 23px;
    top: 8px;
    line-height: 20px;
}

.error-more {
    font-size: 12px;
    color: #FF3A62;
    position: absolute;
    right: 12px;
    top: 10px;
    cursor: pointer;
}

.error-more-icon {
    width: 8px;
    position: absolute;
    right: 0;
    top: 15px;
    cursor: pointer;
}

.error-value-box {
    margin-top: 12px;
    margin-bottom: 20px;
    line-height: 14px;
    font-size: 14px;
    color: #FFFFFF;
    position: relative;
    height: 14px;
    text-align: center;
}

.value1 {
    position: absolute;
    left: 43px;
}

.value2 {
    position: absolute;
    left: 172px;
}

.value3 {
    position: absolute;
    left: 304px;
}

.right-box {
    margin-right: 42px;
    background: rgba(0, 0, 0, 0.25);
    position: relative;
}

.right-title-box {
    width: 1261px;
    height: 58px;
    background-image: url("~@/assets/home/12bg.png");
}

.d-right {
    left: 196px;
}

.d-content {
    width: 100%;
    display: flex;
    margin-left: 6px;
}

.d-left {
    width: 350px;
    margin-left: 21px;
}

.d-left-top {
    width: 350px;
    height: 415px;
    background: rgba(0, 111, 255, 0.06);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid rgba(0, 136, 255, 0.5);
}

.d-left-top:not(:first-child) {
    margin-top: 20px;
}

.d-title {
    width: 100%;
    height: 69px;
    position: relative;
}

.d-icon {
    width: 20px;
    position: absolute;
    left: 18px;
    top: 14px
}

.d-text {
    font-size: 29px;
    color: #1CB9FF;
    font-family: PM;
    position: absolute;
    left: 49px;
    top: 11px;
    line-height: 29px;
}

.d-time {
    font-size: 14px;
    color: #1CB9FF;
    position: absolute;
    left: 113px;
    top: 13px;
}

.d-sub-icon {
    width: 328px;
    position: absolute;
    left: 18px;
    top: 30px;
}

.avg-hr-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.avg-hr-left {
    width: 159px;
    margin-left: 10px;
    position: relative;
    height: 128px;
}

.avg-hr-bg {
    width: 159px;
    position: absolute;
    left: 0;
    top: 0;
}

.avg-hr-num {
    font-size: 34px;
    color: #FFFFFF;
    font-family: CK;
    letter-spacing: 2px;
    width: 159px;
    text-align: center;
    z-index: 11;
    position: absolute;
    top: 17px;
}

.avg-hr-text {
    font-size: 14px;
    color: #FFFFFF;
    width: 159px;
    text-align: center;
    position: absolute;
    bottom: 0;
}

.avg-hr-right {
    width: 159px;
    margin-right: 10px;
    position: relative;
    height: 128px;
}


.range-title-box {
    width: 296px;
    height: 49px;
    position: relative;
    margin: 0 auto;
}

.range-left {
    width: 110px;
    height: 2px;
    background: linear-gradient(270deg, #1E98EA 0%, rgba(5, 27, 55, 0) 100%);
    position: absolute;
    left: 0px;
    top: 25px;
}

.range-right {
    width: 110px;
    height: 2px;
    background: linear-gradient(90deg, #1E98EA 0%, rgba(5, 27, 55, 0) 100%);
    right: 0px;
    top: 25px;
    position: absolute;
}

.range-text {
    font-size: 16px;
    font-family: PM;
    position: absolute;
    left: 110px;
    top: 17px;
    color: #FFFFFF;
    width: 76px;
    text-align: center;
}

.range-box {
    display: flex;
}

.range-box-left {
    width: 137px;
    height: 137px;
    margin-top: 5px;
    margin-left: 21px;
    margin-right: 21px;
    position: relative;
}

#range-chart {
    width: 137px;
    height: 137px;
}

.range-icon {
    width: 48px;
    position: absolute;
    left: 45px;
    top: 45px;
}

.range-box-right {
    width: 170px;
    height: 170px;
    position: relative;
}

.range-bar0 {
    width: 10px;
    height: 10px;
    background: #1CB9FF;
    position: absolute;
    left: 0;
    top: 4px;
}

.range-bar1 {
    width: 10px;
    height: 10px;
    background: #0CE989;
    position: absolute;
    left: 0;
    top: 60px;
}

.range-bar2 {
    width: 10px;
    height: 10px;
    background: #FFBC36;
    position: absolute;
    left: 0;
    top: 116px;
}

.range-text0 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 18px;
    top: 0;
}

.range-text1 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 18px;
    top: 56px;
}

.range-text2 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 18px;
    top: 112px;
}

.range-value0 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 18px;
    top: 23px;
}

.range-value1 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 18px;
    top: 79px;
}

.range-value2 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 18px;
    top: 135px;
}

.range-value-num0 {
    font-size: 16px;
    color: #1CB9FF;
    font-family: CK;
    letter-spacing: 2px;
}

.range-value-num1 {
    font-size: 16px;
    color: #0CE989;
    font-family: CK;
    letter-spacing: 2px;
}

.range-value-num2 {
    font-size: 16px;
    color: #FFBC36;
    font-family: CK;
    letter-spacing: 2px;
}

.avg-sleep-box {
    width: 330px;
    height: 59px;
    display: flex;
    justify-content: space-between;
    margin: -10px auto 18px;
}

.avg-sleep-item {
    width: 170px;
    background-image: url("~@/assets/home/18sleepBg0.png");
    background-size: cover;
    box-sizing: border-box;
    height: 77px;
    position: relative;
}

.avg-sleep-item:not(:first-child) {
    background-image: url("~@/assets/home/18sleepBg1.png");
}

.avg-sleep-title {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 60px;
    top: 16px;
}

.avg-sleep-value {
    font-size: 16px;
    font-family: CK;
    letter-spacing: 1px;
    color: #1CB9FF;
    position: absolute;
    left: 60px;
    top: 36px;
}

.avg-sleep-value1 {
    color: #FFBC36;
}

.four-phase {
    font-size: 16px;
    color: #FFFFFF;
    font-family: PM;
    margin-left: 18px;
    margin-bottom: -5px;
    padding-top: 5px;
}

.four-phase-item {
    width: 316px;
    margin: 15px auto 0;
    position: relative;
    height: 29px;
}

.four-phase-title {
    width: 62px;
    height: 29px;
    position: absolute;
    left: 0;
    top: 0;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 29px;
    padding-left: 1px;
}

.four-phase-title0 {
    background: linear-gradient(90deg, #2D4EF2 0%, rgba(5, 29, 59, 0) 100%);
}

.four-phase-title1 {
    background: linear-gradient(90deg, #0078E2 0%, rgba(5, 29, 59, 0) 100%);
}

.four-phase-title2 {
    background: linear-gradient(90deg, #009BCC 0%, rgba(5, 29, 59, 0) 100%);
}

.four-phase-title3 {
    background: linear-gradient(90deg, #FF3A62 0%, rgba(5, 29, 59, 0) 100%);
}

.four-phase-value {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 66px;
    top: -3px;
}

.four-phase-progress-bg {
    width: 250px;
    height: 6px;
    border-radius: 3px 3px 3px 3px;
    opacity: 0.25;
    position: absolute;
    left: 66px;
    top: 20px;
}

.four-phase-progress-bg0 {
    background: #3551DE;
}

.four-phase-progress-bg1 {
    background: #2D81FF;
}

.four-phase-progress-bg2 {
    background: #1CB9FF;
}

.four-phase-progress-bg3 {
    background: #FF3A62;
}

.four-phase-progress-value {
    height: 6px;
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    left: 66px;
    top: 20px;
}

.four-phase-progress-value0 {
    background: linear-gradient(90deg, #3551DE 0%, #6E86FF 100%);
    box-shadow: 0px 0px 6px 1px #3456FF;
}

.four-phase-progress-value1 {
    background: linear-gradient(90deg, #2D81FF 0%, #61A0FF 100%);
    box-shadow: 0px 0px 6px 1px #1793FF;
}

.four-phase-progress-value2 {
    background: linear-gradient(90deg, #19ABFF 0%, #61D9FF 100%);
    box-shadow: 0px 0px 6px 1px #37BBFF;
}

.four-phase-progress-value3 {
    background: linear-gradient(90deg, #FF3A62 0%, #FF6080 100%);
    box-shadow: 0px 0px 6px 1px #FF2A55;
}

.four-phase-level {
    height: 19px;
    border-radius: 3px 3px 3px 3px;
    position: absolute;
    right: 0;
    top: -3px;
    text-align: center;
    font-size: 14px;
    line-height: 19px;
    padding: 0 8px;
}

.four-phase-level-normal {
    background: rgba(28, 185, 255, 0.2);
    color: #1CB9FF;
}

.four-phase-level-low {
    background: rgba(12, 233, 137, 0.2);
    color: #0CE989;
}

.four-phase-level-high {
    background: rgba(255, 58, 98, 0.2);
    color: #FF3A62;
}

.sleep-num-box {
    width: 330px;
    display: flex;
    justify-content: space-between;
    margin: 9px auto 18px;
}

.sleep-num-item {
    width: 170px;
    background-image: url("~@/assets/home/19sleepBg.png");
    background-size: cover;
    box-sizing: border-box;
    height: 72px;
    position: relative;
}

.sleep-num-value {
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    padding-top: 6px;
}

.sleep-num-num0 {
    font-size: 20px;
    color: #FFBC36;
    font-family: CK;
    margin-right: 3px;
}

.sleep-num-num1 {
    font-size: 20px;
    color: #FF3A62;
    font-family: CK;
    margin-right: 3px;
}

.sleep-num-key {
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
}

.pressure-chart-box {
    width: 100%;
    height: 170px;
    position: relative;
}

#pressure-chart {
    width: 100%;
    height: 200px;
    position: absolute;
    top: -15px;
}

.avg-pressure {
    width: 96px;
    height: 96px;
    background: #051024;
    border-radius: 50%;
    position: absolute;
    left: 126px;
    top: 36px;
}

.avg-pressure0 {
    box-shadow: inset 0px 0px 10px 1px #0CE989;
    border: 1px solid rgba(12, 233, 137, 0.5);
}

.avg-pressure1 {
    box-shadow: inset 0px 0px 10px 1px #1CB9FF;
    border: 1px solid rgba(28, 185, 255, 0.5);
}

.avg-pressure2 {
    box-shadow: inset 0px 0px 10px 1px #FFBC36;
    border: 1px solid rgba(255, 188, 54, 0.5);
}

.avg-pressure3 {
    box-shadow: inset 0px 0px 10px 1px #FF3A62;
    border: 1px solid rgba(255, 58, 98, 0.5);
}

.avg-pressure-value {
    font-size: 34px;
    text-align: center;
    font-family: CK;
    margin-top: 7px;
}

.avg-pressure-value0 {
    color: #0CE989;
}

.avg-pressure-value1 {
    color: #1CB9FF;
}

 .avg-pressure-value2 {
    color: #FFBC36;
}

 .avg-pressure-value3 {
    color: #FF3A62;
}

.avg-pressure-key {
    font-size: 14px;
    color: #ffffff;
    text-align: center;
}

.pressure-sub-title {
    position: relative;
    margin-top: 6px;
    width: 100%;
    height: 20px;
}

.pressure-sub-title-text {
    color: #ffffff;
    font-size: 16px;
    letter-spacing: 1.5px;
    text-align: center;
    z-index: 1;
    position: absolute;
    left: 106px;
}

.pressure-sub-title-bg {
    height: 9px;
    background: linear-gradient(180deg, rgba(5, 27, 54, 0) 0%, #FF3A62 100%);
    width: 148px;
    position: absolute;
    left: 101px;
    top: 14px;
    z-index: 0;
}

.pressure-bar-box {
    width: 100%;
    height: 156px;
    position: relative;
}

#pressure-bar-chart {
    width: 100%;
    height: 130px;
    position: absolute;
    top: 30px;
}

.pressure-num-unit {
    font-size: 10px;
    color: #FFFFFF;
    position: absolute;
    left: 18px;
    top: 6px
}

.select-pressure {
    width: 100%;
    text-align: center;
    position: absolute;
    font-size: 10px;
    color: #FFFFFF;
    top: 10px
}

.select-pressure-num {
    font-size: 16px;
    color: #FF3A62;
    font-family: CK;
    margin: 0 4px 0 8px;
}

.avg-bos-item {
    width: 154px;
    background-image: url("~@/assets/home/20bosUser.png");
    background-size: cover;
    box-sizing: border-box;
    height: 60px;
    position: relative;
    margin-top: 5px;
}

.avg-bos-item:not(:first-child) {
    background-image: url("~@/assets/home/20bosNum.png");
}

.avg-bos-item .avg-sleep-title {
    top: 10px;
    left: 64px;
}

.avg-bos-item .avg-sleep-value {
    top: 29px;
    left: 64px;
}

.avg-bos-box {
    width: 316px;
}

.bos-chart-box {
    width: 160px;
    height: 160px;
    position: relative;
    margin: 30px auto 0;
}

#bos-chart {
    width: 160px;
    height: 160px;
}

.bos-icon {
    width: 52px;
    position: absolute;
    top: 48px;
    left: 60px;
}

.pressure-ratio-box {
    width: 100%;
    height: 105px;
    position: relative;
}

.pressure-bar0 {
    width: 10px;
    height: 10px;
    background: #1CB9FF;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    left: 29px;
    top: 22px;
}

.pressure-bar1 {
    width: 10px;
    height: 10px;
    background: #FFBC36;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    left: 142px;
    top: 22px;
}

.pressure-bar2 {
    width: 10px;
    height: 10px;
    background: #FF3A62;
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    left: 246px;
    top: 22px;
}

.pressure-text0 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 47px;
    top: 18px;
}

.pressure-text1 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 160px;
    top: 18px;
}

.pressure-text2 {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 264px;
    top: 18px;
}

.pressure-text-ratio-num0 {
    font-size: 16px;
    color: #1CB9FF;
    font-family: CK;
    position: absolute;
    left: 47px;
    top: 38px;
}

.pressure-text-ratio-num1 {
    font-size: 16px;
    color: #FFBC36;
    font-family: CK;
    position: absolute;
    left: 160px;
    top: 38px;
}

.pressure-text-ratio-num2 {
    font-size: 16px;
    color: #FF3A62;
    font-family: CK;
    position: absolute;
    left: 264px;
    top: 38px;
}

.pressure-text-num0 {
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    left: 38px;
    top: 63px;
}

.pressure-text-num1 {
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    left: 151px;
    top: 63px;
}

.pressure-text-num2 {
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    left: 255px;
    top: 63px;
}

.ecg-box {
    width: 462px;
    height: 850px;
    background: rgba(0, 111, 255, 0.06);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid rgba(0, 136, 255, 0.5);
    margin-left: 21px;
}

.ecg-total-box {
    width: 422px;
    height: 38px;
    box-shadow: inset 0px 0px 8px 1px #0090FF;
    border-radius: 0px 0px 0px 0px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ecg-total-key {
    font-size: 14px;
    color: #FFFFFF;
}

.ecg-total-value {
    font-size: 20px;
    color: #1CB9FF;
    font-family: CK;
    margin-left: 12px;
    letter-spacing: 2px;
}

.ecg-test-box {
    display: flex;
    justify-content: space-between;
    margin: 12px 20px;
}

.ecg-test-item {
    width: 136px;
    background-image: url("~@/assets/home/21ecg0.png");
    background-size: cover;
    box-sizing: border-box;
    height: 58px;
    position: relative;
}

.ecg-test-item:nth-child(2) {
    background-image: url("~@/assets/home/21ecg1.png");
}

.ecg-test-item:nth-child(3) {
    background-image: url("~@/assets/home/21ecg2.png");
}

.ecg-test-title {
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    left: 55px;
    top: 12px;
}

.ecg-test-value {
    font-size: 16px;
    color: #1CB9FF;
    font-family: CK;
    position: absolute;
    left: 55px;
    top: 30px;
    letter-spacing: 2px;
}

.ecg-level {
    font-size: 14px;
    margin-left: 4px;
    font-family: "微软雅黑";
}

.ecg-error-box {
    width: 422px;
    height: 395px;
    box-shadow: inset 0px 0px 10px 1px #006FFF;
    margin: 23px auto 19px;
    position: relative;
}

.ecg-error-title {
    width: 112px;
    height: 23px;
    background: #05152D;
    box-shadow: inset 0px -2px 2px 1px rgba(0, 128, 255, 0.8);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    left: 155px;
    top: -12px;
    color: #1CB9FF;
    font-size: 16px;
    font-family: PM;
    text-align: center;
    line-height: 23px;
}

.ecg-error-info {
    width: 390px;
    margin-left: 20px;
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
}

.ecg-error-left {
    width: 50%;
    display: flex;
    align-items: end;
}

.ecg-error-type-order {
    width: 16px;
    height: 16px;
    background: #2D81FF;
    border-radius: 50%;
    font-size: 12px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ecg-error-type {
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 4px;
}

.ecg-error-right {
    font-size: 14px;
    color: #FFFFFF;
    width: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: end;
}

.ecg-error-num {
    font-size: 20px;
    color: #1CB9FF;
    font-family: CK;
    margin-right: 4px;
}

.ecg-error-progress-bg {
    width: 390px;
    height: 6px;
    border-radius: 3px 3px 3px 3px;
    background: rgba(53, 81, 222, 0.25);
    position: relative;
    margin-top: 10px;
    margin-left: 20px;
}

.ecg-error-progress-value {
    height: 6px;
    background: linear-gradient(90deg, #2E82FF 0%, #31D7FF 100%);
    box-shadow: 0px 0px 6px 1px #347EFF;
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    top: 0;
}

.ecg-hr-item {
    width: 183px;
    height: 138px;
    text-align: center;
    position: relative;
}

.ecg-hr-title {
    width: 183px;
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    z-index: 1;
}

.ecg-hr-value {
    width: 183px;
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    z-index: 1;
    top: 26px;
}

.ecg-hr-num {
    font-size: 34px;
    font-family: CK;
    letter-spacing: 2px;
}

.ecg-icon {
    width: 183px;
    position: absolute;
    bottom: 24px;
    left: 0;
}

.ecg-hr-box {
    display: flex;
    margin: 0 auto;
    width: 386px;
    justify-content: space-between;
}

#hrv-chart {
    width: 100%;
    height: 200px;
    position: absolute;
    top: -15px;
}

.avg-hrv {
    width: 96px;
    height: 96px;
    background: #051024;
    border-radius: 50%;
    position: absolute;
    left: 183px;
    top: 36px;
}

.no-error-user {
    text-align: center;
    padding-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue